import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";

interface ICategoryState {
  subCategoryId: number | null;
  subCategoryTypeId: number | null;
  searchTerm: string;
  selectedState: string;
}

const initialState: ICategoryState = {
  subCategoryId: null,
  subCategoryTypeId: null,
  searchTerm: '',
  selectedState: 'all'
};

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setSubCategoryId: (state, action: PayloadAction<number | null>) => {
      state.subCategoryId = action.payload;
    },
    clearSubCategoryId: (state) => {
      state.subCategoryId = null;
    },
    setSubCategoryTypeId: (state, action: PayloadAction<number | null>) => {
      state.subCategoryTypeId = action.payload;
    },
    clearSubCategoryTypeId: (state) => {
      state.subCategoryTypeId = null;
    },

    // Filter reducer
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    setSelectedState: (state, action: PayloadAction<string>) => {
      state.selectedState = action.payload;
    },
    resetFilter: (state) => {
      state.searchTerm = '';
      state.selectedState = 'all';
      state.subCategoryId = null;
      state.subCategoryTypeId = null;
    }
  },
});

export const { setSubCategoryId, clearSubCategoryId,setSubCategoryTypeId,clearSubCategoryTypeId, setSearchTerm, setSelectedState, resetFilter } = categorySlice.actions;

// Selector
export const selectSubCategoryId = (state: RootState) =>
  state.category.subCategoryId;

export const selectSubCategoryTypeId = (state: RootState) =>
    state.category.subCategoryTypeId;

export const selectSearchTerm = (state: RootState) => state.category.searchTerm;
export const selectSelectedState = (state: RootState) => state.category.selectedState;

export default categorySlice.reducer;
